import {Component, EventEmitter, Input, Output} from '@angular/core';
import {aiMapping} from "../../../services/ai/definitions/aiMapping";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatIconModule} from "@angular/material/icon";
import {MatFormFieldModule} from "@angular/material/form-field";
import {TranslocoModule} from "@ngneat/transloco";

@Component({
    selector: 'app-ai-settings',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        MatCheckboxModule,
        MatIconModule,
        MatFormFieldModule,
        TranslocoModule
    ],
    templateUrl: './ai-settings.component.html',
    styleUrls: ['./ai-settings.component.scss']
})
export class AiSettingsComponent {
    @Input() aiSettings: any;
    @Output() aiSettingsChange = new EventEmitter<any>();

    chatOptions = aiMapping.chat.options;
    createImageOptions = aiMapping.createImage.options;
    editImageOptions = aiMapping.editImage.options;
    createVideoOptions = aiMapping.createVideo.options;
    editVideoOptions = aiMapping.editVideo.options;

    onAssistantChange() {
        this.aiSettingsChange.emit(this.aiSettings);
    }
}